import React from 'react';

const Feedback = (props) => (
    <div className={'form-text ' + (!!props.additionalClasses ? props.additionalClasses : '')}>
        {props.text}
    </div>
);

export default Feedback;